<template>
    <a-modal
    title="祺信详情"
    v-model="modalShow"
    width="80%"
    :footer="null"
    @cancel="close"
    destroyOnClose>
        <div class='gold-page'>
            <div class="spaceBetween">
                <div>
                    <div class="gold-line">开立日：{{pageData.estbDay | dateFormat('YYYY-mm-dd')}}</div>
                    <div class="gold-line">到期日：{{pageData.exDay | dateFormat('YYYY-mm-dd')}}</div>
                </div>
                <div style="font-weight:bold;font-size:18px;position: relative;left:20px;">祺信</div>
                <div>
                    <div class="gold-line">状态：
                        {{pageData.isPledged == 1 ? (pageData.pledgeStatus | pledgeStatus)
                        : pageData.gldStCd | GbGldStCdTrans}}
                    </div>
                    <div class="gold-line">编号：{{pageData.gldId}}</div>
                </div>
            </div>
            <table class="gold-detail-table">
                <tr v-if="pageData.isPledged != 1">
                    <td>流转方</td>
                    <td>{{ pageData.pyptNm }}</td>
                    <td>统一社会信用代码</td>
                    <td>{{ pageData.pyptOrgCode }}</td>
                </tr>
                <tr v-if="pageData.isPledged != 1">
                    <td>接收方</td>
                    <td>{{ pageData.rcPtyNm || pageData.tenantNm || pageData.tenantName}}</td>
                    <td>统一社会信用代码</td>
                    <td>{{ pageData.rcPtyOrgCode || pageData.tenantOrgCode }}</td>
                </tr>
                <tr>
                    <td>开立方</td>
                    <td>{{ pageData.estbNm }}</td>
                    <td>统一社会信用代码</td>
                    <td>{{ pageData.estbOrgCode }}</td>
                </tr>
                <tr v-if="pageData.grtStCd == 2">
                    <td>保证人</td>
                    <td>{{ pageData.guarantorName }}</td>
                    <td>统一社会信用代码</td>
                    <td>{{ pageData.guarantorOrgCode }}</td>
                </tr>
                <tr v-if="pageData.isPledged == 1">
                    <td>出质人</td>
                    <td>{{ pageData.pledgorNm }}</td>
                    <td>统一社会信用代码</td>
                    <td>{{ pageData.pledgorOrgCode }}</td>
                </tr>
                <tr v-if="pageData.isPledged == 1">
                    <td>质权人</td>
                    <td>{{ pageData.pledgeeName }}</td>
                    <td>统一社会信用代码</td>
                    <td>{{ pageData.pledgeeOrgCode }}</td>
                </tr>
                <tr>
                    <td colspan="4" style="height:50px;">
                        <span>祺信金额</span>
                        <span style="margin-left:60px;">(大写){{ pageData.bigGldAmt }}</span>
                        <span style="margin-left:160px;">(小写)¥{{ pageData.gldAmt | splitK }}</span>
                    </td>
                </tr>
                <!-- <tr v-if="pageData.grtStCd == 2">
                    <td colspan="4" style="height:50px;">
                        <span>保证金额</span>
                        <span style="margin-left:60px;">(大写){{ pageData.bigGrtAmt }}</span>
                        <span style="margin-left:160px;">(小写)¥{{ pageData.grtAmt | splitK }}</span>
                    </td>
                </tr>
                <tr>
                    <td>保理商</td>
                    <td>{{ pageData.tenantName }}</td>
                    <td>统一社会信用代码</td>
                    <td>{{ pageData.tenantOrgCode }}</td>
                </tr> -->
                <tr>
                    <td colspan="4">
                        <span>
                        开立方声明：我司已对本祺信出具《付款承诺函（{{pageData.firstGldId}}
                            ）》，到期无条件依据持票方明细付款。    承诺日期：{{ pageData.signTime | dateFormat('YYYY-mm-dd')}}
                        </span>
                    </td>
                </tr>
                <tr v-if="+pageData.isPledged !== 1">
                    <td colspan="4" class="detail-table__remarks">
                        <span v-if="+pageData.canBeModified === 0">备注：本祺信可以全部或部分流转支付<span v-if="pageData.firstGldId !== pageData.gldId">，也可以随时申请融资</span>。</span>
                        <span v-if="+pageData.canBeModified === 1 || +pageData.canBeModified === 3">备注：本祺信可以全部或部分流转支付<span v-if="pageData.firstGldId !== pageData.gldId">，也可以随时申请融资</span>。<b>开立方可对本祺信的到期日期进行变更，变更后的祺信到期日期将早于{{pageData.exDay | dateFormat('YYYY-mm-dd')}}。</b></span>
                        <span v-if="+pageData.canBeModified === 2">备注：本祺信可以全部或部分流转支付<span v-if="pageData.firstGldId !== pageData.gldId">，也可以随时申请融资</span>。<b>开立方已于{{pageData.modifiedDay | dateFormat('YYYY-mm-dd')}}，将到期日期由{{pageData.beforeModified|dateFormat('YYYY-mm-dd')}}变更为{{pageData.afterModified|dateFormat('YYYY-mm-dd')}}。</b></span>
                    </td>
                </tr>
                <tr v-if="+pageData.isPledged === 1">
                    <td colspan="4" class="detail-table__remarks">
                        <span>备注：本祺信已质押,清分款项需先用于偿还出质人的债务.</span>
                    </td>
                </tr>
            </table>
            <div class="spaceBetween" style="margin-top:10px;">
              <template v-if="!isFnc">
                <div>
                    <div class="gold-line">流转方财务记账建议：</div>
                    <div class="gold-line">借：应付账款-{{pageData.rcPtyNm || pageData.tenantNm || pageData.tenantName}} </div>
                    <div class="gold-line">贷：应付账款-祺信({{pageData.gldId}}） </div>
                </div>
                <div>
                    <div class="gold-line">接收方财务记账建议：</div>
                    <div class="gold-line">借：应收账款-祺信({{pageData.gldId}}） </div>
                    <div class="gold-line">贷：应收账款-{{pageData.pyptNm}} </div>
                </div>
              </template>
              <template v-else>
                <div>
                    <div class="gold-line">流转方财务记账建议：</div>
                    <div class="gold-line">借：银行存款</div>
                    <div class="gold-line" style="margin-left:28px">财务费用</div>
                </div>
                <div>
                    <div class="gold-line"></div>
                    <div class="gold-line">贷：应收账款-祺信({{pageData.gldId}}） </div>
                </div>
              </template>
            </div>
        </div>
        <goldDetailOriginInfo v-if="gldId" :goldIdParam.sync="gldId"></goldDetailOriginInfo>
    </a-modal>
</template>

<script>
import {mapMutations,mapGetters} from "vuex"
import {getDetailApi} from '@/api/gold.js'
import goldDetailOriginInfo from "@/components/gold-page/gold-detail-origin-info"
export default {
    props:{
        id:{
            type:String,
            default:function(){
                return ""
            }
        },
        info:{
            type:Object,
            default:function(){
                return null
            }
        },
        isFnc:{
          type:Boolean

        }
    },
    components:{
        goldDetailOriginInfo
    },
    name:"gold-detail-dialog",
    data() {
        return {
            pageData:{},
            modalShow:false,
            gldId:undefined
        }
    },
    computed: {
        ...mapGetters({
            userObj:"home/getUserObj",
            parentData:"app/getGoldDetailPrarms"

        }),
    },
    created() {
    },
    mounted() {},
    methods: {
        ...mapMutations({
            setBuyOrSell:"app/setBuyOrSell",
        }),
        getGoldDetail(){
            if(this.id || this.info){
                let param = {
                    gldId:this.id
                }
                if(this.info){
                    param = {
                        ...this.info
                    }
                }
                this.gldId = param.gldId;
                getDetailApi(param,true)
                .then(res => {
                    this.$set(this,'pageData',res.data)
                    // this.pageData = res.data;
                }).catch(err => {
                    console.log(err);
                });
            }
        },
        open(){
            this.modalShow = true;
            this.getGoldDetail();
        },
        close(){
            this.modalShow = false;
        }
    },
    watch: {
        id(newVal){
            this.getGoldDetail();
        }
    },
    activated() {}
}
</script>
<style scoped>
    .gold-page{
        margin:15px 0 20px 0;
    }
    .gold-line{
        margin-bottom: 10px;
    }
    .gold-detail-table{
        width: 100%;
        font-family: MicrosoftYaHei;
        border-collapse: collapse;
        padding: 0;
        font-weight: normal;
        font-size: 12px;
        color: #0D253E;
        letter-spacing: 0;
        border: 1px solid #9EA8B2;
    }
    .gold-detail-table td{
        padding: 10px 15px;
        box-sizing: border-box;
        border: 1px solid #9EA8B2;
    }
    .gold-detail-table td:first-child{
        padding-left: 53px;
        width: 140px;
    }
    .gold-detail-table td:nth-child(3){
        width: 140px;
    }
    .gold-btns{
        margin:40px 0 30px 0;
    }
    .gold-btns button{
        margin:0 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/gold-page/gold-detail-dialog.vue